module.exports = __webpack_public_path__ + "static/media/vk-icon.cd31c169.svg";